import React from 'react';
import { Box, Typography } from '@mui/material';
import {
    AutorenewOutlinedIcon,
    PersonOutlineOutlinedIcon,
    EmailOutlinedIcon,
    CalendarTodayOutlinedIcon,
    LockOutlinedIcon
} from 'icons/materialIcons';
import { COLORS } from 'styles/colors';

const categories = [
    {
        name: 'CRM',
        description: 'Sync Touch leads to your CRM',
        icon: AutorenewOutlinedIcon
    },
    {
        name: 'HR',
        description: 'Sync team members from HR directory',
        icon: PersonOutlineOutlinedIcon
    },
    {
        name: 'Email',
        description: 'Sync leads and email signatures',
        icon: EmailOutlinedIcon
    },
    {
        name: 'SAML',
        description: 'Set up SSO login',
        icon: LockOutlinedIcon
    },
    {
        name: 'Calendar Booking',
        description: 'Set up calendar integrations',
        icon: CalendarTodayOutlinedIcon
    }
];

const IntegrationsCategoriesMenu = ({ activeCategory, onCategoryChange }) => {
    const handleCategoryClick = (categoryName) => {
        onCategoryChange(categoryName);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 3,
                width: 'fit-content',
                pl: 3,
                mb: 4,
                position: 'relative',
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: '24px',
                    right: 0,
                    height: '1px',
                    backgroundColor: COLORS.darkGrey
                }
            }}
        >
            {categories.map((category) => {
                const Icon = category.icon;
                const isActive = activeCategory === category.name;

                return (
                    <Box
                        key={category.name}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            cursor: 'pointer',
                            pb: 1,
                            position: 'relative',
                            transition: 'border-color 0.3s ease'
                        }}
                        onClick={() => handleCategoryClick(category.name)}
                    >
                        <Icon
                            sx={{
                                color: isActive ? COLORS.lightBlue : COLORS.darkGrey,
                                fontSize: 18
                            }}
                        />
                        <Typography
                            variant="subtitle2"
                            sx={{
                                color: isActive ? COLORS.lightBlue : '#818181',
                                fontSize: '0.75rem',
                                fontWeight: isActive ? 600 : 400,
                                '&:hover': {
                                    color: COLORS.lightBlue
                                }
                            }}
                        >
                            {category.name}
                        </Typography>
                        {isActive && (
                            <Box
                                sx={{
                                    position: 'absolute',
                                    bottom: '-1px',
                                    left: 0,
                                    right: 0,
                                    height: '4px',
                                    backgroundColor: COLORS.lightBlue
                                }}
                            />
                        )}
                    </Box>
                );
            })}
        </Box>
    );
};

export default IntegrationsCategoriesMenu;